import { ApiResponse, createRequestFilters, ICustomFilter, ISortRequest } from '@enter/core';
import _ from 'lodash';

export interface IFetchResourceRequest {
    pageSize?: number;
    page?: number;
    sortRequest?: ISortRequest;
    filters?: ICustomFilter[];
}

type RequestOptions =
    | {
          limit: number | undefined;
          offset: number | undefined;
          sort: any[] | undefined;
          order: any[] | undefined;
      }
    | { [filterKey: string]: string };

export function createRequestOptions(req: IFetchResourceRequest, sortEnum: any, orderEnum: any): RequestOptions {
    // Make sure that we don;t pass anything that we don't support on the server
    const sort: any[] | undefined = req.sortRequest
        ? req.sortRequest.sort.filter(s => Object.values(sortEnum).includes(s))
        : undefined;
    const order: any[] | undefined = req.sortRequest
        ? req.sortRequest.order.filter(o => Object.values(orderEnum).includes(o))
        : undefined;

    const reqFilters = createRequestFilters(req.filters);

    const offset = _.has(req, 'page') && _.has(req, 'pageSize') ? Number(req.page) * Number(req.pageSize) : undefined;

    return {
        limit: req.pageSize,
        offset,
        sort,
        order,
        ...reqFilters,
    };
}

interface IFetchListResponse<T> {
    value: T[];
    limit: number;
    offset: number;
    total: number;
}

export async function parseFetchListRaw<T = any>(raw: ApiResponse<T[]>): Promise<IFetchListResponse<T>> {
    const value = await raw.value();
    const limit = await Number(raw.raw.headers.get('pagination-limit'));
    const offset = await Number(raw.raw.headers.get('pagination-offset'));
    const total = await Number(raw.raw.headers.get('pagination-total'));

    return { value, limit, offset, total };
}
